/**
 * Counts a page view each time the route changes.
 *
 * Renders nothing. Mounted once inside the router (App.tsx). Sends the path
 * only, never the query string (see lib/analytics).
 *
 * @module AnalyticsRouteTracker
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/shared/lib/analytics';

/**
 * Reports the current path to Umami on every route change.
 *
 * @returns Nothing to draw.
 */
export function AnalyticsRouteTracker(): null {
  const { pathname } = useLocation();
  useEffect(() => { trackPageView(pathname); }, [pathname]);
  return null;
}
